import { useState } from 'react'
import { supabase } from '../lib/supabase'
import { getTodayDate } from '../lib/utils'

export default function Review({ userId }) {
  const today = getTodayDate()
  const [review, setReview] = useState({
    type: 'daily',
    completed_blocks: '',
   未完成_blocks: '',
    focus_score: 5,
    mood: 3,
    todo_tomorrow: '',
  })
  const [saving, setSaving] = useState(false)
  const [saved, setSaved] = useState(false)

  const handleSubmit = async (e) => {
    e.preventDefault()
    setSaving(true)

    const { error } = await supabase.from('gaokao_reviews').insert({
      user_id: userId,
      date: today,
      type: review.type,
      content: {
        completed_blocks: review.completed_blocks,
        unfinished_blocks: review.unfinished_blocks,
        focus_score: review.focus_score,
        mood: review.mood,
        todo_tomorrow: review.todo_tomorrow,
      },
    })

    setSaving(false)
    if (!error) setSaved(true)
  }

  if (saved) {
    return (
      <div className="max-w-2xl mx-auto p-4">
        <div className="card p-8 text-center">
          <div className="text-4xl mb-4">✓</div>
          <h2 className="text-xl font-bold mb-2">复盘已保存</h2>
          <p className="text-ink-500">今天辛苦了，明天继续加油！</p>
          <button onClick={() => setSaved(false)} className="btn-ghost mt-4">
            重新编辑
          </button>
        </div>
      </div>
    )
  }

  return (
    <div className="max-w-2xl mx-auto p-4">
      <h1 className="text-2xl font-bold mb-6">每日复盘</h1>

      <form onSubmit={handleSubmit} className="card p-6 space-y-4">
        <div>
          <label className="label block mb-1">今天完成了什么</label>
          <textarea
            value={review.completed_blocks}
            onChange={e => setReview({ ...review, completed_blocks: e.target.value })}
            className="input"
            rows="3"
            placeholder="今天学了哪些内容、做了哪些题..."
          />
        </div>

        <div>
          <label className="label block mb-1">哪些没完成/没做好</label>
          <textarea
            value={review.unfinished_blocks}
            onChange={e => setReview({ ...review, unfinished_blocks: e.target.value })}
            className="input"
            rows="3"
            placeholder="哪些计划没完成，为什么..."
          />
        </div>

        <div>
          <label className="label block mb-1">今天专注度 (1-10)</label>
          <input
            type="range"
            min="1"
            max="10"
            value={review.focus_score}
            onChange={e => setReview({ ...review, focus_score: Number(e.target.value) })}
            className="w-full"
          />
          <div className="text-center text-sm mt-1">{review.focus_score}/10</div>
        </div>

        <div>
          <label className="label block mb-1">心情 (1-5)</label>
          <div className="flex gap-2">
            {[1, 2, 3, 4, 5].map(n => (
              <button
                key={n}
                type="button"
                onClick={() => setReview({ ...review, mood: n })}
                className={`flex-1 py-2 rounded-lg border ${
                  review.mood === n
                    ? 'border-accent bg-accent/10'
                    : 'border-ink-300 dark:border-ink-400'
                }`}
              >
                {['😫', '😟', '😐', '😊', '🤩'][n - 1]}
              </button>
            ))}
          </div>
        </div>

        <div>
          <label className="label block mb-1">明天最重要的3件事</label>
          <textarea
            value={review.todo_tomorrow}
            onChange={e => setReview({ ...review, todo_tomorrow: e.target.value })}
            className="input"
            rows="3"
            placeholder="明天要完成的任务..."
          />
        </div>

        <button type="submit" disabled={saving} className="btn-primary w-full">
          {saving ? '保存中...' : '保存复盘'}
        </button>
      </form>
    </div>
  )
}
